export default {
    basename: '/', // only at build time to set, like ///able-pro/react/default
    rtlLayout: false,
    i18n: 'es',
    jwt: {
        secret: 'SECRET-KEY',
        timeout: '1 days',
    },
};
